import { CircularProgress, CircularProgressProps } from '@mui/material';
import { DetailedHTMLProps, HTMLAttributes } from 'react';


type ProgressIndicatorProps = DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    size?: number;
    color?: CircularProgressProps['color'];
};

export function ProgressIndicator({ size = 24, color = 'primary', ...props }: ProgressIndicatorProps) {
    return (
        <div {...props}>
            <CircularProgress
                color={color}
                size={size}
            />
        </div>
    );
}
